import { render, staticRenderFns } from "./RandomSix.vue?vue&type=template&id=477ffdb6&"
import script from "./RandomSix.vue?vue&type=script&lang=js&"
export * from "./RandomSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports